export default "__VITE_ASSET__BaqNvpGy__"